module.exports = __webpack_public_path__ + "img/quard5.fc66cb02.png";